/**
 * @generated SignedSource<<800beff416ecdd8211298cfa4a63f2bd>>
 * @relayHash 8044e66d6d14d3c8d608ad17b4c7a655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343

import type { ConcreteRequest } from 'relay-runtime';
export type UserAuthTokenForExtensionInput = {
  contextIds: ReadonlyArray<string>;
  extensionId: string;
};
export type useFetchAuthToken_forge_ui_userAuthTokenMutation$variables = {
  input: UserAuthTokenForExtensionInput;
};
export type useFetchAuthToken_forge_ui_userAuthTokenMutation$data = {
  readonly userAuthTokenForExtension: {
    readonly authToken: {
      readonly token: string;
      readonly ttl: number;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useFetchAuthToken_forge_ui_userAuthTokenMutation = {
  response: useFetchAuthToken_forge_ui_userAuthTokenMutation$data;
  variables: useFetchAuthToken_forge_ui_userAuthTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserAuthTokenForExtensionResponse",
    "kind": "LinkedField",
    "name": "userAuthTokenForExtension",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "AuthToken",
        "kind": "LinkedField",
        "name": "authToken",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "token"
          },
          {
            "kind": "ScalarField",
            "name": "ttl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343",
    "metadata": {},
    "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d3c16ce08d98682bc3fa0189ab747c05";

export default node;
